/**
 * Client fallbacks when the price-configuration API is unavailable.
 * Keep defaults aligned with backend env (DEFAULT_WEAR_COST_PER_KM_CHF, FALLBACK_CHF_TO_EUR_RATE).
 */

export const FALLBACK_WEAR_COST_PER_KM_CHF = 0.76;

export const FALLBACK_CHF_TO_EUR_RATE = 1.07;
